import { getRouteArtistSlug } from "./routePaths";

const fanHubPageTypes = new Set(["bio", "songs", "albums", "videos"]);
const nonFanHubRootPaths = new Set(["redirect", "r", "admin", "newsletter", "members", "branches", "merch", "games"]);

export const getFanHubPathParts = (pathname: string) => pathname.split("/").filter(Boolean);

export const isFanHubPagePath = (pathname: string) => {
  const parts = getFanHubPathParts(pathname);

  if (parts.length === 0) return true;
  if (nonFanHubRootPaths.has(parts[0])) return false;
  if (parts.length === 1) return fanHubPageTypes.has(parts[0]) || !parts[0].includes(".");
  if (parts.length === 2) return fanHubPageTypes.has(parts[1]);

  return false;
};

export const resolveFanHubArtistUsername = (pathname: string) => {
  const parts = getFanHubPathParts(pathname);
  return getRouteArtistSlug(parts);
};
